<div class="main-container" [@pageFadeUp]>
  <app-embedded-loader [show]="showLoader"></app-embedded-loader>

  <app-buyer-supplier-chat
    [headerData]="headerData"
    [isOpen]="isChatOpen"
    [rfqId]="headerData?.rfqId"
    [userId]="userIdAsString"
    [isSupplier]="userRole === 'Suppliers'"
    (close)="closeChat()"
  ></app-buyer-supplier-chat>

  <div class="title-text">Invoices</div>
  <div class="section" [@staggerFadeUp]>
    <div class="search-filter-container stagger-item">
      <div class="search-container">
        <input
          type="text"
          [(ngModel)]="searchParam"
          placeholder="Search on Invoice Reference, Order Reference, Buyer Name and Keywords"
          class="search-input"
          (keyup.enter)="onSearch()"
        />
        <button class="search-button" (click)="onSearch()">
          <mat-icon>search</mat-icon> Search
        </button>
      </div>
      <div class="search-filter-content">
        <mat-form-field class="date-field" appearance="fill">
          <mat-label>From Date</mat-label>
          <input
            matInput
            [matDatepicker]="fromDatepicker"
            placeholder="DD/MM/YYYY"
            [(ngModel)]="fromDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="fromDatepicker"
            [disabled]="false"
          ></mat-datepicker-toggle>
        </mat-form-field>
        <mat-datepicker #fromDatepicker></mat-datepicker>

        <mat-form-field class="date-field" appearance="fill">
          <mat-label>To Date</mat-label>
          <input
            matInput
            [matDatepicker]="toDatepicker"
            placeholder="DD/MM/YYYY"
            [(ngModel)]="toDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="toDatepicker"
            [disabled]="false"
          ></mat-datepicker-toggle>
        </mat-form-field>
        <mat-datepicker #toDatepicker></mat-datepicker>
        <div class="search-filter-button-container">
          <button type="submit" class="search-btn" (click)="onSearch()">
            <mat-icon>search</mat-icon>
          </button>
          <button type="button" class="close-button" (click)="cancelFilter()">
            <mat-icon>cancel</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="filter-statuses stagger-item">
      <button
        *ngFor="let status of filterStatuses; let i = index"
        class="status-btn"
        [ngClass]="{ active: activeIndex === i }"
        (click)="onStatusSelect(status.name, i, status.label)"
        matTooltip="{{ status.label }}"
      >
        <div style="display: flex; flex-direction: column; line-height: 1.1">
          <span>{{ status.name | uppercase }}</span>
          <!-- <span *ngIf="status.subtext" style="font-size: 11px; opacity: 0.8">{{
            status.subtext
          }}</span> -->
        </div>
      </button>

      <!-- <div class="more-dropdown" [class.open]="dropdownOpen">
        <button class="status-btn more-btn" (click)="toggleDropdown()">
          More...
        </button>
        <div class="dropdown-menu" *ngIf="dropdownOpen">
          <button
            *ngFor="let extra of filterStatusesRfqAndQuote; let j = index"
            class="dropdown-item"
            (click)="
              onStatusSelect(
                extra.name,
                filterStatuses.length + j,
                extra.label
              );
              toggleDropdown()
            "
            matTooltip="{{ extra.label }}"
          >
            {{ extra.name | uppercase }}
          </button>
        </div>
      </div> -->
    </div>

    <div
      class="filter-section stagger-item"
      *ngIf="this.selectedInvoices.length > 0"
      style="display: flex; align-items: center"
    >
      <div style="margin-left: 20px">
        <b
          >Selected {{ this.selectedInvoices.length }} of
          {{ this.totalRecords }} Invoices</b
        >
      </div>

      <button
        style="position: relative; bottom: 3px"
        mat-icon-button
        mat-sm-button
        color="primary"
        class="mr-1"
        matTooltipClass="mat-tooltip-custom"
        matTooltip="Archive"
        matTooltipPosition="below"
        (click)="invoiceOperation('archive')"
      >
        <mat-icon>archive</mat-icon>
      </button>
    </div>

    <div class="dropdown-container-active stagger-item">
      <div class="text-right" style="display: inline-flex; align-items: center">
        <button
          mat-mini-fab
          matTooltip="Export All"
          matTooltipPosition="below"
          (click)="exportAllInvoices()"
        >
          <mat-icon
            matTooltipClass="mat-tooltip-custom"
            svgIcon="downloadExcel"
          ></mat-icon>
        </button>
      </div>

      <div style="width: 7%; display: flex; justify-content: flex-end; align-items: center">
        <div>
          <button mat-fab class="green-button" [matMenuTriggerFor]="menu" matTooltip="Show more columns">
            <mat-icon style="position: relative; right: -3px">playlist_add</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item *ngFor="let item of items" (click)="toggleSelection(item)">
              <mat-checkbox [checked]="item.selected">{{ item.label }}</mat-checkbox>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>

    <div class="active-table-container stagger-item">
      <ngx-datatable
        style="border-radius: 5px"
        #supplierTable
        class="material expandable bg-light supplier-table sup-tbl"
        [rows]="documentData"
        [headerHeight]="50"
        [footerHeight]="50"
        [rowHeight]="'auto'"
        [columnMode]="'force'"
        [limit]="limit"
        [count]="totalRecords"
        [externalPaging]="true"
        [externalSorting]="true"
        [scrollbarH]="false"
        [offset]="offset"
        (page)="onPageChange($event)"
        (sort)="onSort($event)"
        [rowClass]="setRowClass"
      >
        <!-- Invoice Number -->
        <ngx-datatable-column name="Invoice Number" prop="invoiceNumber" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="Order-Reference"
              matTooltip="{{ row.invoiceRefNumber }}"
              matTooltipPosition="below"
              (click)="openInvoice(row)"
            >
              {{ row.invoiceRefNumber }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <!-- Order Reference -->
        <ngx-datatable-column name="Order Reference" prop="purchaseOrderNumber" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="rfq-reference"
              matTooltip="{{ row.purchaseOrderRefNumber }}"
              matTooltipPosition="below"
              (click)="openPOPreview(row)"
            >
              {{ row.purchaseOrderRefNumber || "-" }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <!-- RFQ Reference -->
        <ngx-datatable-column name="RFQ Reference" prop="rfqRefNumber" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <a
              class="rfq-ref"
              matTooltip="{{ row.rfqRefNumber }}"
              matTooltipPosition="below"
              [routerLink]="['/dashboard/rfq/create/header']"
              [queryParams]="{ productType: 'cart', rfqId: row.rfqId }"
            >
              {{ row.rfqRefNumber || "-" }}
            </a>
          </ng-template>
        </ngx-datatable-column>

        <!-- Quote Reference -->
        <ngx-datatable-column name="Quote Reference" prop="quoteRefNumber" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <a
              class="quote-ref"
              matTooltip="{{ row.quoteRefNumber }}"
              matTooltipPosition="below"
              [routerLink]="['/dashboard/quote/create/preview']"
              [queryParams]="{ rfqId: row.rfqId, quoteId: row.quoteId }"
            >
              {{ row.quoteRefNumber || "-" }}
            </a>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column *ngFor="let column of selectedColumns" [name]="column.label" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span>
              <span *ngIf="isDate(row[column.prop])" matTooltip="{{ row[column.prop] | date: 'dd/MM/yyyy' : '-' }}" matTooltipPosition="below">
                {{ row[column.prop] | date: 'dd/MM/yyyy' : '-' }}
              </span>
              <span *ngIf="!isDate(row[column.prop])" matTooltip="{{ row[column.prop] || '-' }}" matTooltipPosition="below">
                {{ row[column.prop] || '-' }}
              </span>
            </span>
          </ng-template>
        </ngx-datatable-column>

        <!-- Supplier -->
        <ngx-datatable-column name="Supplier" [flexGrow]="0.8" [sortable]="false">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="Buyer"
              matTooltip="{{ getSupplierDisplay(row) }}"
              matTooltipPosition="below"
            >
              {{ getSupplierDisplay(row) }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <!-- Amount (not sortable on backend) -->
        <ngx-datatable-column name="Amount" [flexGrow]="0.8" [sortable]="false">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="Amount"
              matTooltip="{{ getDisplayAmount(row) }}"
              matTooltipPosition="below"
            >
              {{ getDisplayAmount(row) }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <!-- DueDate -->
        <ngx-datatable-column name="Due Date" prop="dueDate" [flexGrow]="0.8">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="Due-Date"
              matTooltip="{{ formatDueDate(row) }}"
              matTooltipPosition="below"
            >
              {{ formatDueDate(row) }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <!-- Status (not sortable on backend) -->
        <ngx-datatable-column name="Status" [flexGrow]="0"
          [minWidth]="100"
          [maxWidth]="120" [sortable]="false">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="status-pill status-link"
              [ngStyle]="{ color: getStatusColor(row.invoiceStatus) }"
              matTooltip="{{ getStatusLabel(row) }}"
              matTooltipPosition="below"
              (click)="openMarkInvoicePaidModal(row)"
            >
              {{ getStatusLabel(row) }}
            </span>
          </ng-template>
        </ngx-datatable-column>


                 <!-- Dispatch Status (not sortable on backend) -->
                 <ngx-datatable-column name="Dispatch Status" [flexGrow]="0"
                    [minWidth]="100"
                    [maxWidth]="120" [sortable]="false">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <span class="Amount" matTooltip="{{row.dispatchStatus}}" matTooltipPosition="below">
                      {{ row.dispatchStatus }}
                    </span>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Delivery Status" [flexGrow]="0"
                    [minWidth]="100"
                    [maxWidth]="120" [sortable]="false">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <span class="Amount" matTooltip="{{row.deliveryStatus}}" matTooltipPosition="below">
                      {{ row.deliveryStatus }}
                    </span>
                  </ng-template>
                </ngx-datatable-column>

                
        <ngx-datatable-column
        name="Contact/Print/Download"
        [resizeable]="true"
        [sortable]="false"
        [flexGrow]="0"
        [minWidth]="170"
        [maxWidth]="200"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="action-buttons-container">
           
      
            <button
              mat-icon-button
              color="primary"
              matTooltip="Buyer contact Details"
              matTooltipPosition="below"
              (click)="toggleContactPopUp(true, row)"
            >
              <mat-icon>local_phone</mat-icon>
            </button>

            <button 
            mat-icon-button color="primary" 
            matTooltip="Print" 
            matTooltipPosition="below" 
            [matMenuTriggerFor]="printMenu">
              <mat-icon>print</mat-icon>
            </button>
            
            <!-- Dropdown Menu -->
            <mat-menu #printMenu="matMenu">
              <button mat-menu-item (click)="generateInvoicePdf(row,'Commercial Invoice')">
                <mat-icon>print</mat-icon>
                <span>Print Commercial Invoice</span>
              </button>
              <button mat-menu-item (click)="generateInvoicePdf(row,'Packaging List')">
                <mat-icon>print</mat-icon>
                <span>Print Packing Slip</span>
              </button>
              <button mat-menu-item (click)="generateInvoicePdf(row,'Delivery Note')">
                <mat-icon>print</mat-icon>
                <span>Print Delivery Note</span>
              </button>
            </mat-menu>
            
            
            <button 
            mat-icon-button color="primary" 
            matTooltip="Download" 
            matTooltipPosition="below"
            [matMenuTriggerFor]="downloadMenu">
              <mat-icon>download</mat-icon>
            </button>
            
            <!-- Dropdown Menu -->
            <mat-menu #downloadMenu="matMenu">
              <button mat-menu-item (click)="generateInvoiceExcel(row,'Commercial Invoice')">
                <mat-icon>download</mat-icon>
                <span>Download Commercial Invoice</span>
              </button>
              <button mat-menu-item (click)="generateInvoiceExcel(row,'Packaging List')">
                <mat-icon>download</mat-icon>
                <span>Download Packing Slip</span>
              </button>
              <button mat-menu-item (click)="generateInvoiceExcel(row,'Delivery Note')">
                <mat-icon>download</mat-icon>
                <span>Download Delivery Note</span>
              </button>
            </mat-menu>

      

            
          </div>
        </ng-template>
      </ngx-datatable-column>

        <!-- Action (not sortable) -->
        <ngx-datatable-column name="Action" [flexGrow]="0"
        [minWidth]="170"
        [maxWidth]="200" [sortable]="false">
          <ng-template let-column="column" ngx-datatable-header-template>
            <span>Action</span>
          </ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="action-buttons-container">
              <button
              mat-icon-button
              color="primary"
              matTooltipClass="mat-tooltip-custom"
              (click)="confirmOrderReceipt(row.dispatchId, row)"
              matTooltip="Confirm Order Receipt"
              matTooltipPosition="below"
            >
              <mat-icon>receipt_long</mat-icon>
            </button>

              <button
                mat-icon-button
                color="primary"
                matTooltipClass="mat-tooltip-custom"
                (click)="onViewClick(row)"
                matTooltip="View"
                matTooltipPosition="below"
              >
                <mat-icon>visibility</mat-icon>
              </button>
              <button
                mat-icon-button
                color="primary"
                matTooltipClass="mat-tooltip-custom"
                (click)="onChatClick(row)"
                matTooltip="Chat"
                matTooltipPosition="below"
              >
                <mat-icon>chat</mat-icon>
              </button>
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
          [sortable]="false"
          [maxWidth]="55"
          [minWidth]="55"
        >
          <ng-template ngx-datatable-header-template>
            <input
              type="checkbox"
              [checked]="
                this.selectedInvoices.length == this.documentData.length
              "
              (change)="toggleSelectAll($event, 'active')"
            />
          </ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <input
              type="checkbox"
              [checked]="isChecked(row.invoiceId, 'active')"
              (change)="selectDeselectInvoice($event, row.invoiceId, 'active')"
            />
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>

    <div class="archive-container stagger-item" #heading>
      <span
        style="
          padding-left: 16px;
          padding-top: 16px;
          margin-bottom: 20px;
          font-weight: bold;
          display: flex;
          justify-content: space-between;
          padding-right: 20px;
        "
        (click)="toggleArchived()"
      >
        <div style="display: inline-flex; align-items: center">
          <span style="margin-left: 4px">Archived Documents</span>
        </div>
        <mat-icon>
          {{ isArchivedExpand ? "expand_less" : "expand_more" }}
        </mat-icon>
      </span>

      <ng-container *ngIf="isArchivedExpand">
        <div
          class="filter-section-selection-container"
          style="display: flex; align-items: center"
          *ngIf="this.selectedArchivedInvoices.length > 0"
        >
          <div style="margin-left: 10px">
            <b
              >Selected {{ this.selectedArchivedInvoices.length }} of
              {{ this.archivedTotalRecords }} archived Invoices</b
            >
          </div>

          <button
            style="position: relative; bottom: 3px"
            mat-icon-button
            mat-sm-button
            color="primary"
            class="mr-1"
            matTooltipClass="mat-tooltip-custom"
            matTooltip="Unarchive"
            matTooltipPosition="below"
            (click)="invoiceOperation('unarchive')"
          >
            <mat-icon>unarchive</mat-icon>
          </button>
        </div>

        <div class="dropdown-container">
          <button mat-fab class="green-button" [matMenuTriggerFor]="archivedMenu" matTooltip="Show more columns">
            <mat-icon style="position: relative; right: -3px">playlist_add</mat-icon>
          </button>
          <mat-menu #archivedMenu="matMenu">
            <button mat-menu-item *ngFor="let item of archivedItems" (click)="archivedToggleSelection(item)">
              <mat-checkbox [checked]="item.selected">{{ item.label }}</mat-checkbox>
            </button>
          </mat-menu>
        </div>

        <ngx-datatable
          style="border-radius: 5px"
          #archivedSection
          class="material expandable bg-light supplier-table sup-tbl"
          [rows]="archivedDocumentData"
          [headerHeight]="50"
          [footerHeight]="50"
          [rowHeight]="'auto'"
          [columnMode]="'force'"
          [limit]="archivedLimit"
          [count]="archivedTotalRecords"
          [externalPaging]="true"
          [externalSorting]="true"
          [scrollbarH]="false"
          [offset]="archivedOffset"
          (page)="onArchivedPageChange($event)"
          (sort)="onArchivedSort($event)"
          [rowClass]="setRowClass"
        >
          <!-- Invoice Number -->
          <ngx-datatable-column name="Invoice Number" prop="invoiceNumber" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="Order-Reference"
                matTooltip="{{ row.invoiceRefNumber }}"
                matTooltipPosition="below"
                (click)="openInvoice(row)"
              >
                {{ row.invoiceRefNumber }}
              </span>
            </ng-template>
          </ngx-datatable-column>

          <!-- Order Reference -->
          <ngx-datatable-column name="Order Reference" prop="purchaseOrderNumber" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="rfq-reference"
                matTooltip="{{ row.purchaseOrderRefNumber }}"
                matTooltipPosition="below"
                (click)="openPOPreview(row)"
              >
                {{ row.purchaseOrderRefNumber || "-" }}
              </span>
            </ng-template>
          </ngx-datatable-column>

          <!-- RFQ Reference -->
          <ngx-datatable-column name="RFQ Reference" prop="rfqRefNumber" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <a
                class="rfq-ref"
                matTooltip="{{ row.rfqRefNumber }}"
                matTooltipPosition="below"
                [routerLink]="['/dashboard/rfq/create/header']"
                [queryParams]="{ productType: 'cart', rfqId: row.rfqId }"
              >
                {{ row.rfqRefNumber || "-" }}
              </a>
            </ng-template>
          </ngx-datatable-column>

          <!-- Quote Reference -->
          <ngx-datatable-column name="Quote Reference" prop="quoteRefNumber" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <a
                class="quote-ref"
                matTooltip="{{ row.quoteRefNumber }}"
                matTooltipPosition="below"
                [routerLink]="['/dashboard/quote/create/preview']"
                [queryParams]="{ rfqId: row.rfqId, quoteId: row.quoteId }"
              >
                {{ row.quoteRefNumber || "-" }}
              </a>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column *ngFor="let column of archivedSelectedColumns" [name]="column.label" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span>
                <span *ngIf="isDate(row[column.prop])" matTooltip="{{ row[column.prop] | date: 'dd/MM/yyyy' : '-' }}" matTooltipPosition="below">
                  {{ row[column.prop] | date: 'dd/MM/yyyy' : '-' }}
                </span>
                <span *ngIf="!isDate(row[column.prop])" matTooltip="{{ row[column.prop] || '-' }}" matTooltipPosition="below">
                  {{ row[column.prop] || '-' }}
                </span>
              </span>
            </ng-template>
          </ngx-datatable-column>

          <!-- Supplier -->
          <ngx-datatable-column name="Supplier" [flexGrow]="0.8" [sortable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="Buyer"
                matTooltip="{{ getSupplierDisplay(row) }}"
                matTooltipPosition="below"
              >
                {{ getSupplierDisplay(row) }}
              </span>
            </ng-template>
          </ngx-datatable-column>

          <!-- Amount (not sortable) -->
          <ngx-datatable-column name="Amount" [flexGrow]="0.8" [sortable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="Amount"
                matTooltip="{{ getDisplayAmount(row) }}"
                matTooltipPosition="below"
              >
                {{ getDisplayAmount(row) }}
              </span>
            </ng-template>
          </ngx-datatable-column>

          <!-- DueDate -->
          <ngx-datatable-column name="DueDate" prop="dueDate" [flexGrow]="0.8">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="Due-Date"
                matTooltip="{{ formatDueDate(row) }}"
                matTooltipPosition="below"
              >
                {{ formatDueDate(row) }}
              </span>
            </ng-template>
          </ngx-datatable-column>

          <!-- Status (not sortable) -->
          <ngx-datatable-column name="Status" [minWidth]="150" [flexGrow]="0.8" [sortable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="status-pill status-link"
              [ngStyle]="{ color: getStatusColor(row.invoiceStatus) }"
              matTooltip="{{ getStatusLabel(row) }}"
              matTooltipPosition="below"
              (click)="openMarkInvoicePaidModal(row)"
            >
              {{ getStatusLabel(row) }}
            </span>
          </ng-template>
        </ngx-datatable-column>

          <!-- Selection Checkbox Column -->
          <ngx-datatable-column
            [sortable]="false"
            [maxWidth]="55"
            [minWidth]="55"
          >
            <ng-template ngx-datatable-header-template>
              <input
                type="checkbox"
                [checked]="this.selectedArchivedInvoices.length == this.archivedDocumentData.length && this.archivedDocumentData.length > 0"
                (change)="toggleSelectAll($event, 'archived')"
              />
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <input
                type="checkbox"
                [checked]="isChecked(row.invoiceId, 'archived')"
                (change)="selectDeselectInvoice($event, row.invoiceId, 'archived')"
              />
            </ng-template>
          </ngx-datatable-column>

        </ngx-datatable>
      </ng-container>
    </div>

    <!-- Modal -->
    <div id="markInvoicePaidModal" class="mark-invoice-paid-modal" [ngClass]="{ open: isMarkInvoicePaidModalOpen }">
      <div class="mark-invoice-paid-content">
        <form [formGroup]="markInvoiceAsPaidForm" (ngSubmit)="onSaveMarkInvoiceAsPaid()">
          <h3 class="mark-invoice-paid-title">MARK INVOICE AS PAID</h3>

          <div class="mark-invoice-paid-section">
            <h4 class="section-title">Payment Details</h4>
            <div class="section-grid">
              <input type="text" placeholder="Invoice Number" formControlName="invoiceRefNumber" readonly />
              <input type="text" placeholder="Supplier Name" formControlName="supplierCompanyName" readonly />
              <input type="text" placeholder="Amount Due" formControlName="amountDue" readonly />
            </div>
          </div>

          <div class="mark-invoice-paid-section">
            <div class="section-grid">
              <div class="form-group">
                <label>Payment Date*</label>
                <input type="date" formControlName="paymentDate" />
              </div>

              <div class="form-group">
                <label>Amount Paid*</label>
                <input type="number" placeholder="Enter amount" formControlName="amountPaid" />
              </div>

              <div class="form-group">
                <label>Payment Method*</label>
                <select formControlName="paymentMethod">
                  <option value="">Select Method</option>
                  <option>Bank Transfer</option>
                  <option>Credit Card</option>
                  <option>Cheque</option>
                  <option>Cash</option>
                </select>
              </div>

              <div class="form-group">
                <label>Transaction/Reference Number*</label>
                <input type="text" placeholder="Enter transaction number" formControlName="transactionRefNumber" />
              </div>

              <div class="form-group">
                <label>From Account</label>
                <input type="text" placeholder="Enter from account" formControlName="fromAccount" />
              </div>

              <div class="form-group">
                <label>To Account</label>
                <input type="text" placeholder="Enter to account" formControlName="toAccount" />
              </div>

              <div class="form-group full-width">
                <label>Additional Notes</label>
                <textarea placeholder="Enter notes" formControlName="notes"></textarea>
              </div>

              <div class="form-group">
                <label>Upload Payment Proof*</label>
                <div style="display: inline-flex; align-items: center; gap: 8px">
                  <ng-container *ngIf="showSaveButton; else paidProofView">
                    <ng-container *ngIf="!getPaymentProofUrl(); else hasProofEditing">
                      <input type="file" accept="image/*,application/pdf" (change)="onProofSelected($event)" />
                    </ng-container>
                    <ng-template #hasProofEditing>
                      <a
                        [href]="getPaymentProofUrl()"
                        target="_blank"
                        rel="noopener"
                        matTooltip="View uploaded proof"
                        aria-label="View uploaded proof"
                      >
                        <mat-icon>visibility</mat-icon>
                      </a>
                      <span>{{ getPaymentProofFileName() }}</span>
                    </ng-template>
                  </ng-container>
                  <ng-template #paidProofView>
                    <ng-container *ngIf="getPaymentProofUrl(); else noFilePaid">
                      <a
                        [href]="getPaymentProofUrl()"
                        target="_blank"
                        rel="noopener"
                        matTooltip="View uploaded proof"
                        aria-label="View uploaded proof"
                      >
                        <mat-icon>visibility</mat-icon>
                      </a>
                      <span>{{ getPaymentProofFileName() }}</span>
                    </ng-container>
                    <ng-template #noFilePaid>
                      <span>No file selected</span>
                    </ng-template>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>

          <div class="mark-invoice-paid-actions">
            <button type="button" class="close-btn" (click)="closeMarkInvoicePaidModal()">Close</button>
            <button *ngIf="showSaveButton" type="submit" class="save-btn">Mark as Paid</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>


<app-contact-details
  [showContactPopup]="showContactPopup"
  [contactData]="selectedSupplier"
  (close)="showContactPopup = false">
</app-contact-details>
